import styled from '@emotion/styled'

import { ButtonLink } from '@/components/Button'
import { Container } from '@/components/Container'
import { CONFIG } from '@/styles/emotion.config'

export const MediaContainer = styled(Container)`
  .media-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;

    ${CONFIG.media.xlg} {
      padding: 0;
      gap: 2rem;
      justify-content: space-between;
      flex-direction: row;
    }
  }
`

export const SectionImageContainer = styled.div`
  align-items: flex-start;
  justify-content: flex-end;
`

export const SectionTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  ${CONFIG.media.xlg} {
    align-items: flex-start;
    gap: 2rem;
  }
`

export const SectionContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  ${CONFIG.media.xlg} {
    max-width: 35.3rem;
    gap: 2rem;
  }
`

export const SectionButtonLink = styled(ButtonLink)`
  max-width: 24rem;
  width: 100%;

  background-color: rgb(var(--colors-pink));
  transition: ease-in-out all 0.2s;

  :hover {
    background-color: rgb(var(--colors-pink));
    filter: brightness(0.9);
  }

  :focus {
    background-color: rgb(var(--colors-pink));
    filter: brightness(1.2);
  }
`

export const SectionFooter = styled.div`
  .media__footer__disclaimer {
    font-size: 0.75rem;
    line-height: 1rem;
  }
`
